export const ACCESS_LEVELS = {
  PUBLIC: 1,
  PRIVATE: 2,
  ADMIN: 3
}
